import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { updateStudent } from "../server/institutionAllApi";
import { Snackbar, Alert, CircularProgress } from "@mui/material";
import { Modal, Button, Form } from "react-bootstrap";

const EditStudent = () => {
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const location = useLocation();
  const studentToEdit = location.state?.student;

  const [formState, setFormState] = useState({
    student_id: "",
    name: "",
    email: "",
    address: "",
    mobile: "",
    education: "",
    gender: "",
    visa_status: "",
  });
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedCourseData, setSelectedCourseData] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [savedDepartmentName, setSavedDepartmentName] = useState("");
  const [savedLevelName, setSavedLevelName] = useState("");
  const [savedCourseName, setSavedCourseName] = useState("");
  const [savedBatchName, setSavedBatchName] = useState("");
  const [departments, setDepartments] = useState([]);
  const [levels, setLevels] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedEducation, setSelectedEducation] = useState("");
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);
  const [token, setToken] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [savedCountryName, setSavedCountryName] = useState("");
  const [savedStateName, setSavedStateName] = useState("");
  const [savedCityName, setSavedCityName] = useState("");
  const [isNameTouched, setIsNameTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [certificateImage, setCertificateImage] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const [selectedBatchToDate, setSelectedBatchToDate] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCopied, setShowCopied] = useState(false);
  const [enrolledCourseData, setEnrolledCourseData] = useState({});
  const [certificateImages, setCertificateImages] = useState({});
  const [imagePreviews, setImagePreviews] = useState({});
  const [asessments, setAssessments] = useState("");
  const [portfolios, setPortfolios] = useState("");
  const [roleName, setRoleName] = useState("");

  // modal
  const [showModal, setShowModal] = useState(false);
  const [selectedModalCourse, setSelectedModalCourse] = useState(null);
  const [amount, setAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");

  const navigate = useNavigate();

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const file = input.target.files[0];

      // Allowed image types
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
      ];

      if (!allowedTypes.includes(file.type)) {
        setSnackbarMessage(
          "Invalid file format! Please upload an image (PNG, JPG, JPEG, GIF)."
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return; // Stop further execution
      }

      // If valid image, read and preview it
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchPortfolios = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("token");
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-portfolios`,
        {
          params: {
            details_id: studentToEdit?._id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("response: ", response.data.data);

      setPortfolios(response.data.data);
    } catch (error) {
      console.error("Failed to fetch Portfolios:", error);
      setError("Failed to fetch Portfolios.");
    } finally {
      setLoading(false);
    }
  };
  const fetchAssessments = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("token");
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-assessment`,
        {
          params: {
            details_id: studentToEdit?._id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("response: ", response.data.data);

      setAssessments(response.data.data);
    } catch (error) {
      console.error("Failed to fetch Assassments:", error);
      setError("Failed to fetch Assassments.");
    } finally {
      setLoading(false);
    }
  };
  const handleImageChange = async (e, courseId) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews((prev) => ({
          ...prev,
          [courseId]: reader.result, // Store preview per course
        }));
        setCertificateImages((prev) => ({
          ...prev,
          [courseId]: file, // Store actual file per course
        }));

        // Call API to update image
        uploadImage(courseId, file);
      };
      reader.readAsDataURL(file);
    }
  };

  // Function to upload image to API
  const uploadImage = async (courseId, file) => {
    const formData = new FormData();
    formData.append("certificateImage", file);
    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/enrolled-course-update-img/${courseId}`,
        formData, // Pass formData directly as the body
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status !== 200) {
        // console.log("Failed to upload image");
      } else {
        // console.log("Upload successful:", response.data);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (studentToEdit) {
      // console.log("student to edit: ", studentToEdit);
      fetchAssessments();
      fetchPortfolios();

      setFormState({
        student_id: studentToEdit?.student_id,
        name: studentToEdit?.name,
        email: studentToEdit?.email,
        address: studentToEdit?.address,
        // country: studentToEdit.country,
        mobile: studentToEdit?.mobile,
        user_name: studentToEdit?.user_name,
        // roll_no: studentToEdit.roll_no,
        education: studentToEdit?.education,
        gender: studentToEdit?.gender,
        visa_status: studentToEdit?.visa_status,
        // state: studentToEdit.state
        // image: studentToEdit.profile_url
        // admission_Date: new Date(studentToEdit.admission_Date).toISOString().split("T")[0], // Format to YYYY-MM-DD
        // gender: studentToEdit.gender,
      });
      setImagePreview(studentToEdit?.profile_url);
      setSavedDepartmentName(studentToEdit?.department?.department_name);
      setSavedLevelName(studentToEdit?.level?.courseCategoryName);
      setSavedCourseName(studentToEdit?.courses?.coursename);
      setSavedBatchName(studentToEdit?.batches?.batch_name);
      setSelectedBatchToDate(studentToEdit?.batches?.batch_end_duration);
      setSavedCountryName(studentToEdit?.countriesData?.name);
      setSavedStateName(studentToEdit?.statesData?.name);
      setSavedCityName(studentToEdit?.cityData?.name);
      setSelectedEducation(studentToEdit?.education);

      setSelectedDepartment(studentToEdit?.department?._id);
      setSelectedLevel(studentToEdit?.level?._id);
      setSelectedCourse(studentToEdit?.courses?._id);
      setSelectedCourseData(studentToEdit?.courses);
      setSelectedBatch(studentToEdit?.batches?._id);
      setSelectedCountry(studentToEdit?.countriesData?._id);
      setSelectedState(studentToEdit?.statesData?._id);
      setSelectedCity(studentToEdit?.cityData?._id);

      // console.log(
      //   "selected department: ",
      //   selectedDepartment,
      //   "selected level: ",
      //   selectedLevel,
      //   "selected course: ",
      //   selectedCourse
      // );

      getErolledStudentById(studentToEdit._id);

      //   setLoading(false); // Stop loading after setting form state
    } else {
      setError("No user data found.");
      //   setLoading(false);
    }
  }, [studentToEdit]);

  const getErolledStudentById = async (id) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-enrolled-course-by-studentid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("response: ", response.data.data[0]);
      if (response.status === 200) {
        setEnrolledCourseData(response.data.data);
        setIsCompleted(response?.data?.data[0]?.completed);
        setImagePreviewUrl(response?.data?.data[0]?.certificateImage);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }

    const user = localStorage?.getItem("user");
    const parsedUser = JSON.parse(user);
    const role = parsedUser?.rolename;
    setRoleName(role);

    fetchBatches();
    fetchdCountry();
  }, []);

  useEffect(() => {
    fetchStatesByCountry();
  }, [selectedCountry]);

  useEffect(() => {
    fetchCityByState();
  }, [selectedState]);

  const fetchBatches = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-batches`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setBatches(response?.data?.data);
      // console.log(response?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchdCountry = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-countries`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCountries(response?.data?.data);
      // console.log(response?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchStatesByCountry = async () => {
    if (!selectedCountry) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-states/${selectedCountry}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setStates(response?.data?.data);
      // console.log(response?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCityByState = async () => {
    if (!selectedState) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-cities/${selectedState}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCities(response?.data?.data);
      // console.log(response?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formState?.name && formState?.name?.length < 2) {
      setError(true);
      return;
    }

    if (formState?.user_name && formState?.user_name?.length < 2) {
      setError(true);
      return;
    }

    if (formState?.mobile?.length < 8 || formState?.mobile?.length > 15) {
      setError(true);
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      // Create a FormData object
      const formData = new FormData();
      formData.append("name", formState?.name);
      formData.append("student_id", formState?.student_id);
      formData.append("user_name", formState?.user_name);
      formData.append("email", formState?.email);
      formData.append("mobile", formState?.mobile);
      formData.append("gender", formState?.gender);
      formData.append("address", formState?.address);
      formData.append("visa_status", formState?.visa_status);
      formData.append("education", selectedEducation);
      formData.append("batch", selectedBatch);
      formData.append("selectedCountry", selectedCountry);
      formData.append("selectedState", selectedState);
      formData.append("selectedCity", selectedCity);
      formData.append("completed", isCompleted);
      // Append the image file (assuming `imagePreview` is the File object)
      const imageInput = document.querySelector("#student-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("image", imageInput.files[0]);
      }

      if (certificateImage)
        formData.append("certificateImage", certificateImage);

      // If editing a student

      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-student/${studentToEdit?._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Ensure the content type is set correctly
          },
        }
      );

      if (response?.status && response?.status === 200) {
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/student-list");
        }, 2000);
      }
    } catch (err) {
      if (err?.response && err?.response?.status === 409) {
        // // console.log("409 error detected");
        setSnackbarMessage(
          "This Email ID is already exists. Please check and update accordingly."
        );
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (err.response && err.response.status === 402) {
        setSnackbarMessage("Please fill out all required fields..");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to update. Please try again");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/student-list");
  };

  const [qualifications] = useState([
    "GCSEs (General Certificate of Secondary Education)",
    "IGCSEs (International General Certificate of Secondary Education)",
    "A-Levels (Advanced Level)",
    "AS Levels (Advanced Subsidiary Level)",
    "BTEC (Business and Technology Education Council) Level 2/3",
    "NVQs (National Vocational Qualifications)",
    "T Levels",
    "BTECs (Level 3 and higher)",
    "Foundation Degrees",
    "Bachelor’s Degrees",
    "Integrated Master’s Degrees",
    "Higher National Certificates (HNCs) and Diplomas (HNDs)",
    "PGCE (Postgraduate Certificate in Education)",
    "Master’s Degrees",
    "Doctorates",
    "Postgraduate Diplomas and Certificates",
    "IELTS (International English Language Testing System)",
    "Cambridge English Qualifications",
    "Scottish Qualifications",
    "Welsh Baccalaureate",
    "International Baccalaureate (IB)",
  ]);

  // for handle img and video
  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   setCertificateImage(file);
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setImagePreviewUrl(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleCheckboxChange = (course) => {
    // console.log("isCompleted: ", isCompleted);

    setIsCompleted(!isCompleted);
  };

  const handleToggleStatus = async (item, e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }
    try {
      const updatedStatus = !item.completed; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/enrolled-course-completed-update/${item._id}`,
        { status: updatedStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Ensure the content type is set correctly
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        // setCommunity((prevtrader) =>
        //   prevtrader.map((b) =>
        //     b._id === item._id ? { ...b, status: updatedStatus } : b
        //   )
        // );
        getErolledStudentById();

        setSnackbarMessage("Course completion Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle course completed:", error);
      setSnackbarMessage(
        "Failed to update course completion status. Please try again."
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleCopy = () => {
    const textToCopy = `https://pglt=43&q=paypal&cvid=bb3beb92655f4d6d4548f7e52e3/${
      selectedCourseData?.fees || "N/A"
    }`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 1000); // Hide after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  // save modal details to payment list
  const handleModalSubmit = async () => {
    if (!selectedModalCourse || !amount || !paymentMode) {
      alert("Please fill in all payment details.");
      return;
    }
    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }

    const paymentData = {
      courseId: selectedModalCourse.course_id,
      details_id: studentToEdit._id,
      amount: amount,
      paymentMode: paymentMode,
      dateOfPayment: new Date().toISOString(),
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/create-course-payment`,
        paymentData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        alert("Payment details saved successfully!");
        setShowModal(false);
        setAmount("");
        setPaymentMode("");
      } else {
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Error saving payment details:", error);
      alert("Failed to save payment details.");
    }
  };

  // modal
  const handleShowModal = (course) => {
    setSelectedModalCourse(course);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setAmount("");
    setPaymentMode("Finance");
  };

  return (
    <>
    <div className="row mt-5">

        {/* Professional Development Table */}
        {/* {roleName === "Admin" && ( */}
          <div className="flex justify-between mt-4 ">
            <div className="mt-4 w-100">
              <h6 className="mb-16">Uploaded Assessment</h6>
              <div className="card-body py-24">
                <div className="table-responsive scroll-sm">
                  <table className="table bordered-table sm-table mb-0">
                    <thead>
                      <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Type</th>
                        <th scope="col">File Name</th>
                        <th scope="col">Action</th>
                        {/* <th scope="col">Status</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {asessments && asessments.length > 0 ? (
                        asessments.map((assessment) => (
                          <tr key={assessment._id}>
                            <td>
                              {new Date(
                                assessment.createdAt
                              ).toLocaleDateString()}
                            </td>
                            <td>Assessment File</td>
                            <td>{assessment.file_name}</td>
                            <td>
                              <a
                                href={assessment.pdf_file}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-primary"
                              >
                                View Assessments
                              </a>
                            </td>
                            {/* <td>
                          <span
                            className={`badge bg-${
                              assessment.status === 1
                                ? "success"
                                : "warning"
                            }`}
                          >
                            {assessment.status === 1
                              ? "Completed"
                              : "In Progress"}
                          </span>
                        </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Assessments found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        {/* )} */}

        {/* Course Notes Table */}
        {/* {roleName === "Admin" && ( */}
          <div className="flex justify-between mt-4">
            <div className="mt-4 w-100">
              <h6 className="mb-16">Uploaded Portfolios</h6>
              <div className="card-body py-24">
                <div className="table-responsive scroll-sm">
                  <table className="table bordered-table sm-table mb-0">
                    <thead>
                      <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Type</th>
                        <th scope="col">File Name</th>
                        <th scope="col">Action</th>
                        {/* <th scope="col">Status</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {portfolios && portfolios.length > 0 ? (
                        portfolios.map((portfolio) => (
                          <tr key={portfolio._id}>
                            <td>
                              {new Date(
                                portfolio.createdAt
                              ).toLocaleDateString()}
                            </td>
                            <td>Portfolio File</td>
                            <td>{portfolio.file_name}</td>
                            <td>
                              <a
                                href={portfolio.pdf_file}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-primary"
                              >
                                View Portfolios
                              </a>
                            </td>
                            {/* <td>
                          <span className={`badge bg-${portfolio.status === 1 ? 'success' : 'warning'}`}>
                            {portfolio.status === 1 ? 'Completed' : 'In Progress'}
                          </span>
                        </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Portfolios found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        {/* )} */}
      </div></>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditStudent;
